import en from '../locales/en.json';
import nl from '../locales/nl.json';

export type Locale = 'en' | 'nl';
const translations: Record<Locale, Record<string, string>> = { en, nl };

export function translate(locale: Locale, key: string, params?: Record<string, string | number>): string {
  let text = translations[locale][key] ?? key;
  Object.entries(params ?? {}).forEach(([name, value]) => {
    text = text.split(`{{${name}}}`).join(String(value));
    text = text.split(`{${name}}`).join(String(value));
  });
  return text;
}
